import { defineStore } from 'pinia';

export const useFocusStore = defineStore('focus', () => {
  const previousElement = ref<string | null>(null);

  function setPreviousElement(el: string | null) {
    previousElement.value = el;
  }

  function restoreFocus() {
    if (previousElement.value && typeof document.getElementById(previousElement.value)?.focus === 'function') {
      document.getElementById(previousElement.value)?.children[0]?.focus();
    }
  }

  function clearFocus() {
    previousElement.value = null;
  }

  return {
    previousElement,
    setPreviousElement,
    restoreFocus,
    clearFocus,
  };
});
